import { create } from "zustand"

type MyJobsStore = {
  postAJobModalOpen: boolean
  setPostAJobModalOpen: (open: boolean) => void
}

export const useMyJobsStore = create<MyJobsStore>((set, get) => ({
  postAJobModalOpen: false,
  setPostAJobModalOpen: (bool: boolean) => {
    set(() => ({ postAJobModalOpen: bool }))
  },
}))

export const useMyJobs = () => {
  const { postAJobModalOpen, setPostAJobModalOpen } = useMyJobsStore()

  return {
    postAJobModalOpen,
    setPostAJobModalOpen,
  }
}
